import React from 'react'

// MUI
import { Box, styled, Card, CardMedia, CardContent, CardActions, Collapse, IconButton, Typography, Button } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Assets
import logo from '../../assets/logo.jpg';
import banner from '../../assets/logo2.webp';

// context
import { useContext } from 'react';
import { SpentContext } from "../../contexts/SpentProvider";

// React Router
import { useNavigate } from 'react-router-dom';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
    variants: [
        {
            props: ({ expand }) => !expand,
            style: {
                transform: 'rotate(0deg)',
            },
        },
        {
            props: ({ expand }) => !!expand,
            style: {
                transform: 'rotate(180deg)',
            },
        },
    ],
}));
export default function Profile() {
    const navigate = useNavigate();

    const myContext = useContext(SpentContext);
    const { count, totalSpent } = myContext;

    const [expanded, setExpanded] = React.useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <Card sx={{ maxWidth: 345, margin: "30px 10px", borderRadius: "20px" }}>
            <CardMedia
                sx={{ height: 180 }}
                image={banner}
                title="spiderman"
            />
            <CardContent>
                <Box sx={{ display: "flex", justifyContent: "flex-start", gap: "15px", alignItems: "center" }}>
                    <CardMedia
                        sx={{ borderRadius: "50%", height: "50px", width: "50px" }}
                        image={logo}
                        title="spiderman"
                    />
                    <Typography gutterBottom variant="h5" component="div">
                        {localStorage.getItem("username") || "Ali Hassan"}
                    </Typography>
                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: "20px" }}>
                    A passionate person about Spider-Man, always inspired by the hero's creativity, persistence, and sense of responsibility. He brings the same enthusiasm and dedication into his own work and personal growth.
                </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: "space-between" }}>
                <Typography variant="h6" color="inherit" sx={{ fontSize: "16px", pl: "10px" }}>Rank: Diamond</Typography>
                <ExpandMore
                    expand={expanded}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="show more"
                >
                    <ExpandMoreIcon />
                </ExpandMore>
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent sx={{ pl: "20px" }}>
                    <Typography sx={{ marginBottom: 2 }}>Gender: {localStorage.getItem("gender") || "Male"}</Typography>
                    <Typography sx={{ marginBottom: 2 }}>Age: {localStorage.getItem("age") || "49"}</Typography>
                    <Typography sx={{ marginBottom: 2 }}>Purchases: {count}</Typography>
                    <Typography sx={{ marginBottom: 2 }}>Spent: {totalSpent}</Typography>
                    <Button onClick={() => {
                        navigate("/edit");
                    }} variant="contained">
                        Edit
                    </Button>
                </CardContent>
            </Collapse>
        </Card>
    )
}
